import React, { forwardRef } from 'react';
import coverBackground from './cover_background.png';
import airwhiteLogo from 'assets/whiteLogo.png';
import styles from '../PDFReportPreview.module.css';

type CoverPageProps = {
    spotAddress: string;
};

const CoverPage = forwardRef<HTMLDivElement, CoverPageProps>(function CoverPage({ spotAddress }, ref) {
    return (
        <div ref={ref} className={styles.pdfPage}>
            <img src={coverBackground} alt="" className={styles.coverBackground} />
            <div className={styles.coverContent}>
                <img src={airwhiteLogo} alt="AirGarage" className={styles.coverLogo} />
                <h1 className={styles.coverTitle}>
                    Revenue
                    <br />
                    Insights
                </h1>
                <p className={styles.coverAddress}>{spotAddress}</p>
            </div>
        </div>
    );
});

export default CoverPage;
